import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { Customer } from "../Model/Customer";
import { CustomerRepository } from "../Repository/CustomerRepository";

export interface GetCustomerUseCase {
  invoke:(page: number, pageSize: number, search: string) => Promise<PaginationResult<Customer>>;
}

export class GetCustomers implements GetCustomerUseCase {
  private colorRepo: CustomerRepository;
  constructor(_ColorRepo: CustomerRepository) {
    this.colorRepo = _ColorRepo;
  }

  async invoke(page: number, pageSize: number, search: string){
     
    const getData = await this.colorRepo.getCustomers(page, pageSize, search);
    return getData;
  }
}